import React from 'react';


type ViewPDFDialogProps = {
    url: string,
    height?: number,
}

const ViewPDFDialog = ({ url, height = 700 }: ViewPDFDialogProps) => {
    return (
        <embed
            src={url + '#navpanes=0&scrollbar=0&pagemode=none"'}
            type="application/pdf"
            height={height}
            width="100%"
        />
    );
};

export default ViewPDFDialog;
